import { Theme, useTheme } from '@mui/material';

import {
  TIconColor,
  TIconVariant,
} from '@/shared/assets/icons/base-icon/base-icon.types';

const getIconColorFromColor = (color: TIconColor, theme: Theme): string => {
  switch (color) {
    case 'primary':
      return theme.palette.primary.main;
    case 'secondary':
      return theme.palette.secondary.main;
    case 'danger':
      return theme.palette.danger.main;
    case 'textPrimary':
      return theme.palette.text.primary;
    case 'textSecondary':
      return theme.palette.text.secondary;
    case 'textAdditional':
      return theme.palette.text.additional!;
    case 'grey':
      return theme.palette.status.grey.text!;
    case 'orange':
      return theme.palette.status.orange.text!;
    case 'green':
      return theme.palette.status.green.text!;
    case 'purple':
      return theme.palette.status.purple.text!;
    case 'blue':
      return theme.palette.status.blue.text!;
    case 'red':
      return theme.palette.status.red.text!;
    case 'yellow':
      return theme.palette.status.yellow.text!;
  }
};

const getIconColorFromVariant = (
  variant: TIconVariant | undefined,
  theme: Theme,
): string => {
  switch (variant) {
    case 'primary':
      return theme.palette.primary.main;
    case 'error':
      return theme.palette.status.red.text!;
    case 'light':
      return theme.palette.secondary.light;
    case 'warning':
      return theme.palette.status.yellow.text!;
    case 'success':
      return theme.palette.status.green.text!;
    case 'info':
      return theme.palette.status.blue.text!;
    default:
      return theme.palette.text.primary;
  }
};

export const useBaseIconColor = (
  variant?: TIconVariant,
  color?: TIconColor,
) => {
  const theme: Theme = useTheme();

  if (color) {
    return getIconColorFromColor(color, theme);
  }

  return getIconColorFromVariant(variant, theme);
};
